const discussionQuestions = [
	{
		id: 1,
		text: 'Hvad er det hårdeste ved at gå på HTX?'
	},
	{
		id: 2,
		text: 'Hvorfor har I valgt HTX?'
	},
	{
		id: 3,
		text: 'Hvorfor har I valgt den studieretning I har?'
	},
	{
		id: 4,
		text: 'Hvilke arrangementer og fester har I på skolen?'
	},
	{
		id: 5,
		text: 'Hvad er jeres yndlingsfag?'
	},
	{
		id: 6,
		text: 'Hvordan ser jeres dag typisk ud?'
	},
	{
		id: 7,
		text: 'Hvad er jeres yndlings ting ved HTX?'
	},
	{
		id: 8,
		text: 'Hvordan er fællesskabet?'
	},
	{
		id: 9,
		text: 'Hvad vil I gerne være efter HTX?'
	},
	{
		id: 10,
		text: 'Hvornår fandt I ud af at det var HTX I gerne ville?'
	},
	{
		id: 11,
		text: 'Overvejede I noget andet end HTX?'
	}
];

export {
	discussionQuestions
};